import { GroupedBarChart } from "components/charts";
import { useMonthlyUsageChart } from "pages/UsagePage/compositions/MonthlyUsageChartProvider";
import React, { memo, useMemo } from "react";
import { ERROR_BOUNDARY_MESSAGES } from "utils/constants";

import { MonthlyData } from "../MonthlyUsageChart/MonthlyUsageChart.utils";
import {
  generateSolarGroupedBarChartConfig,
  getSolarMaxYValue,
} from "./MonthlySolarChart.utils";

type MonthlySolarChartProps = {
  displayType: string;
  thisYearData: MonthlyData[];
};

export const MonthlySolarChart: React.FC<MonthlySolarChartProps> = memo(
  ({ displayType, thisYearData }) => {
    if (!thisYearData || !thisYearData.length) return <></>;

    const { selectedMonthIndex, setSelectedMonthIndex } =
      useMonthlyUsageChart();
    const maxYValue = useMemo(() => {
      return getSolarMaxYValue(thisYearData, displayType);
    }, [thisYearData, displayType]);

    const groupedSolarBarChartConfig = generateSolarGroupedBarChartConfig({
      thisYearData,
      displayType,
    });

    return (
      <GroupedBarChart
        componentTitle={groupedSolarBarChartConfig.chartTitle}
        errorBoundaryMsg={ERROR_BOUNDARY_MESSAGES.chartjs}
        className="chart__container"
        chartConfig={groupedSolarBarChartConfig}
        maxYValue={maxYValue}
        onClickMutation={setSelectedMonthIndex}
        selectedDataIndex={selectedMonthIndex}
      />
    );
  },
);
